import type { Question } from "./questions";

export function normalizeQuestionQuery(value: string): string {
  return value
    .normalize("NFKC")
    .trim()
    .replace(/\s+/gu, " ")
    .toLocaleLowerCase("zh-CN");
}

export function filterQuestions(
  questions: readonly Question[],
  query: string,
): readonly Question[] {
  const terms = normalizeQuestionQuery(query).split(" ").filter(Boolean);
  if (terms.length === 0) return questions;

  return questions.filter((question) => {
    const searchable = normalizeQuestionQuery(
      [
        String(question.id),
        String(question.id).padStart(3, "0"),
        `第${question.id}题`,
        question.scene,
        question.left,
        question.right,
        ...(question.characters ?? []),
      ].join(" "),
    );
    return terms.every((term) => searchable.includes(term));
  });
}
